import { RightOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Form, Row, Typography } from "antd";
import React from "react";
import Masonry from "react-masonry-css";
import { MyInput } from "../../PageComponents";


const { Title, Text } = Typography
const GallaryComponent = () => {

    const [ form ] = Form.useForm()
    
    const images = [
        { id: 1, url: "im-1.jpg", title: "License electrician", },
        { id: 2, url: "im-2.jpg", title: "Beauty consultants",},
        { id: 3, url: "im-3.jpg", title: "Wood engineering",},
        { id: 4, url: "im-4.jpg", title: "Heating and cooling services",},
        { id: 5, url: "im-5.jpg", title: "Licensed Plumbing",},
        { id: 6, url: "im-6.jpg", title: "Painting interior and exterior",},
        { id: 7, url: "im-7.jpg", title: "Professional Junk removal",},
        { id: 8, url: "im-8.jpg", title: "House deep cleaning",},
        { id: 9, url: "im-9.jpg", title: "Carpet cleaning",},
        { id: 10, url: "im-10.jpg", title: "Pressure washing interior and exterior" },
        { id: 11, url: "im-11.jpg", title: "Wood refinishing" },
        { id: 12, url: "im-12.jpg", title: "Kitchen remodel" },
    ];

    const breakpointColumnsObj = {
        default: 4,
        1100: 3,
        700: 2,
        500: 1,
    };


  return (
    <div className="pt-5 container">
        <Row gutter={[24,24]}>
            <Col span={24}>
                <Flex vertical justify="center">
                    <Title level={1} className='gradient-text m-0'>
                        Gallery of Professions
                    </Title>
                    <Text className='text-gray fs-16'
                            >
                        Your next role could be with one of these leading companies.
                    </Text>
                </Flex>
            </Col>
            <Col span={24}>
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-grid_column"
                    >
                    {images.map((image) => (
                        <div key={image.id} className="masonry-item">
                        <img src={'/assets/images/services/'+image.url} alt={image.title} className="gallery-img" />
                        <div className="gallery-info">
                            <h4>{image.title}</h4>
                            <button className="favorite-btn">❤️</button>
                        </div>
                        </div>
                    ))}
                </Masonry>
            </Col>
        </Row>
        
    </div>
  );
};

export {GallaryComponent};
